import React from 'react'

export interface ContextConfig<T> {
  context: React.Context<T>
  value: T
}

export const CompositeContextProvider: React.FC<{
  contexts: ContextConfig<any>[]
  children: React.ReactNode
}> = ({ contexts, children }) => {
  return contexts.reduce<React.ReactElement>((accum, curr) => {
    const ContextProvider = curr.context.Provider
    return (
      // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
      <ContextProvider value={curr.value}>
        {accum}
      </ContextProvider>
    )
  }, (
    <>{children}</>
  ))
}